const DrillData = [
  {
    inch: 0.0019,
    mm: 0.048,
    Drill: '#107',
  },
  {
    inch: 0.002,
    mm: 0.05,
    Drill: '0.05 mm',
  },
  {
    inch: 0.0023,
    mm: 0.058,
    Drill: '#106',
  },
  {
    inch: 0.0027,
    mm: 0.069,
    Drill: '#105',
  },
  {
    inch: 0.0031,
    mm: 0.079,
    Drill: '#104',
  },
  {
    inch: 0.0035,
    mm: 0.089,
    Drill: '#103',
  },
  {
    inch: 0.0039,
    mm: 0.099,
    Drill: '#102',
  },
  {
    inch: 0.0039,
    mm: 0.1,
    Drill: '0.1 mm',
  },
  {
    inch: 0.0043,
    mm: 0.109,
    Drill: '#101',
  },
  {
    inch: 0.0047,
    mm: 0.119,
    Drill: '#100',
  },
  {
    inch: 0.0051,
    mm: 0.13,
    Drill: '#99',
  },
  {
    inch: 0.0055,
    mm: 0.14,
    Drill: '#98',
  },
  {
    inch: 0.0059,
    mm: 0.15,
    Drill: '#97',
  },
  {
    inch: 0.0063,
    mm: 0.16,
    Drill: '#96',
  },
  {
    inch: 0.0067,
    mm: 0.17,
    Drill: '#95',
  },
  {
    inch: 0.0071,
    mm: 0.18,
    Drill: '#94',
  },
  {
    inch: 0.0075,
    mm: 0.191,
    Drill: '#93',
  },
  {
    inch: 0.0079,
    mm: 0.2,
    Drill: '0.2 mm',
  },
  {
    inch: 0.0079,
    mm: 0.201,
    Drill: '#92',
  },
  {
    inch: 0.0083,
    mm: 0.211,
    Drill: '#91',
  },
  {
    inch: 0.0087,
    mm: 0.221,
    Drill: '#90',
  },
  {
    inch: 0.0091,
    mm: 0.231,
    Drill: '#89',
  },
  {
    inch: 0.0095,
    mm: 0.241,
    Drill: '#88',
  },
  {
    inch: 0.01,
    mm: 0.254,
    Drill: '#87',
  },
  {
    inch: 0.0105,
    mm: 0.267,
    Drill: '#86',
  },
  {
    inch: 0.011,
    mm: 0.279,
    Drill: '#85',
  },
  {
    inch: 0.0115,
    mm: 0.292,
    Drill: '#84',
  },
  {
    inch: 0.0118,
    mm: 0.3,
    Drill: '0.3 mm',
  },
  {
    inch: 0.012,
    mm: 0.305,
    Drill: '#83',
  },
  {
    inch: 0.0125,
    mm: 0.318,
    Drill: '#82',
  },
  {
    inch: 0.013,
    mm: 0.33,
    Drill: '#81',
  },
  {
    inch: 0.0135,
    mm: 0.343,
    Drill: '#80',
  },
  {
    inch: 0.0145,
    mm: 0.368,
    Drill: '#79',
  },
  {
    inch: 0.0156,
    mm: 0.397,
    Drill: '1/64 in',
  },
  {
    inch: 0.0158,
    mm: 0.4,
    Drill: '0.4 mm',
  },
  {
    inch: 0.016,
    mm: 0.406,
    Drill: '#78',
  },
  {
    inch: 0.018,
    mm: 0.457,
    Drill: '#77',
  },
  {
    inch: 0.0197,
    mm: 0.5,
    Drill: '0.5 mm',
  },
  {
    inch: 0.02,
    mm: 0.508,
    Drill: '#76',
  },
  {
    inch: 0.021,
    mm: 0.533,
    Drill: '#75',
  },
  {
    inch: 0.0225,
    mm: 0.572,
    Drill: '#74',
  },
  {
    inch: 0.0236,
    mm: 0.6,
    Drill: '0.6 mm',
  },
  {
    inch: 0.024,
    mm: 0.61,
    Drill: '#73',
  },
  {
    inch: 0.025,
    mm: 0.635,
    Drill: '#72',
  },
  {
    inch: 0.026,
    mm: 0.66,
    Drill: '#71',
  },
  {
    inch: 0.0276,
    mm: 0.7,
    Drill: '0.7 mm',
  },
  {
    inch: 0.028,
    mm: 0.711,
    Drill: '#70',
  },
  {
    inch: 0.0292,
    mm: 0.742,
    Drill: '#69',
  },
  {
    inch: 0.031,
    mm: 0.787,
    Drill: '#68',
  },
  {
    inch: 0.0313,
    mm: 0.794,
    Drill: '1/32 in',
  },
  {
    inch: 0.0315,
    mm: 0.8,
    Drill: '0.8 mm',
  },
  {
    inch: 0.032,
    mm: 0.813,
    Drill: '#67',
  },
  {
    inch: 0.033,
    mm: 0.838,
    Drill: '#66',
  },
  {
    inch: 0.035,
    mm: 0.889,
    Drill: '#65',
  },
  {
    inch: 0.0354,
    mm: 0.9,
    Drill: '0.9 mm',
  },
  {
    inch: 0.036,
    mm: 0.914,
    Drill: '#64',
  },
  {
    inch: 0.037,
    mm: 0.94,
    Drill: '#63',
  },
  {
    inch: 0.038,
    mm: 0.965,
    Drill: '#62',
  },
  {
    inch: 0.039,
    mm: 0.991,
    Drill: '#61',
  },
  {
    inch: 0.0394,
    mm: 1.0,
    Drill: '1 mm',
  },
  {
    inch: 0.04,
    mm: 1.016,
    Drill: '#60',
  },
  {
    inch: 0.041,
    mm: 1.041,
    Drill: '#59',
  },
  {
    inch: 0.042,
    mm: 1.067,
    Drill: '#58',
  },
  {
    inch: 0.043,
    mm: 1.092,
    Drill: '#57',
  },
  {
    inch: 0.0433,
    mm: 1.1,
    Drill: '1.1 mm',
  },
  {
    inch: 0.0465,
    mm: 1.181,
    Drill: '#56',
  },
  {
    inch: 0.0469,
    mm: 1.191,
    Drill: '3/64 in',
  },
  {
    inch: 0.0472,
    mm: 1.2,
    Drill: '1.2 mm',
  },
  {
    inch: 0.0512,
    mm: 1.3,
    Drill: '1.3 mm',
  },
  {
    inch: 0.052,
    mm: 1.321,
    Drill: '#55',
  },
  {
    inch: 0.055,
    mm: 1.397,
    Drill: '#54',
  },
  {
    inch: 0.0551,
    mm: 1.4,
    Drill: '1.4 mm',
  },
  {
    inch: 0.0591,
    mm: 1.5,
    Drill: '1.5 mm',
  },
  {
    inch: 0.0595,
    mm: 1.511,
    Drill: '#53',
  },
  {
    inch: 0.0625,
    mm: 1.588,
    Drill: '1/16 in',
  },
  {
    inch: 0.063,
    mm: 1.6,
    Drill: '1.6 mm',
  },
  {
    inch: 0.0635,
    mm: 1.613,
    Drill: '#52',
  },
  {
    inch: 0.0669,
    mm: 1.7,
    Drill: '1.7 mm',
  },
  {
    inch: 0.067,
    mm: 1.702,
    Drill: '#51',
  },
  {
    inch: 0.07,
    mm: 1.778,
    Drill: '#50',
  },
  {
    inch: 0.0709,
    mm: 1.8,
    Drill: '1.8 mm',
  },
  {
    inch: 0.073,
    mm: 1.854,
    Drill: '#49',
  },
  {
    inch: 0.0748,
    mm: 1.9,
    Drill: '1.9 mm',
  },
  {
    inch: 0.076,
    mm: 1.93,
    Drill: '#48',
  },
  {
    inch: 0.0781,
    mm: 1.984,
    Drill: '5/64 in',
  },
  {
    inch: 0.0785,
    mm: 1.994,
    Drill: '#47',
  },
  {
    inch: 0.0787,
    mm: 2.0,
    Drill: '2 mm',
  },
  {
    inch: 0.081,
    mm: 2.057,
    Drill: '#46',
  },
  {
    inch: 0.082,
    mm: 2.083,
    Drill: '#45',
  },
  {
    inch: 0.0827,
    mm: 2.1,
    Drill: '2.1 mm',
  },
  {
    inch: 0.086,
    mm: 2.184,
    Drill: '#44',
  },
  {
    inch: 0.0866,
    mm: 2.2,
    Drill: '2.2 mm',
  },
  {
    inch: 0.089,
    mm: 2.261,
    Drill: '#43',
  },
  {
    inch: 0.0906,
    mm: 2.3,
    Drill: '2.3 mm',
  },
  {
    inch: 0.0935,
    mm: 2.375,
    Drill: '#42',
  },
  {
    inch: 0.0938,
    mm: 2.381,
    Drill: '3/32 in',
  },
  {
    inch: 0.0945,
    mm: 2.4,
    Drill: '2.4 mm',
  },
  {
    inch: 0.096,
    mm: 2.438,
    Drill: '#41',
  },
  {
    inch: 0.098,
    mm: 2.489,
    Drill: '#40',
  },
  {
    inch: 0.0984,
    mm: 2.5,
    Drill: '2.5 mm',
  },
  {
    inch: 0.0995,
    mm: 2.527,
    Drill: '#39',
  },
  {
    inch: 0.1015,
    mm: 2.578,
    Drill: '#38',
  },
  {
    inch: 0.1024,
    mm: 2.6,
    Drill: '2.6 mm',
  },
  {
    inch: 0.104,
    mm: 2.642,
    Drill: '#37',
  },
  {
    inch: 0.1063,
    mm: 2.7,
    Drill: '2.7 mm',
  },
  {
    inch: 0.1065,
    mm: 2.705,
    Drill: '#36',
  },
  {
    inch: 0.1094,
    mm: 2.778,
    Drill: '7/64 in',
  },
  {
    inch: 0.11,
    mm: 2.794,
    Drill: '#35',
  },
  {
    inch: 0.1102,
    mm: 2.8,
    Drill: '2.8 mm',
  },
  {
    inch: 0.111,
    mm: 2.819,
    Drill: '#34',
  },
  {
    inch: 0.113,
    mm: 2.87,
    Drill: '#33',
  },
  {
    inch: 0.1142,
    mm: 2.9,
    Drill: '2.9 mm',
  },
  {
    inch: 0.116,
    mm: 2.946,
    Drill: '#32',
  },
  {
    inch: 0.1181,
    mm: 3.0,
    Drill: '3 mm',
  },
  {
    inch: 0.12,
    mm: 3.048,
    Drill: '#31',
  },
  {
    inch: 0.1221,
    mm: 3.1,
    Drill: '3.1 mm',
  },
  {
    inch: 0.125,
    mm: 3.175,
    Drill: '1/8 in',
  },
  {
    inch: 0.126,
    mm: 3.2,
    Drill: '3.2 mm',
  },
  {
    inch: 0.1285,
    mm: 3.264,
    Drill: '#30',
  },
  {
    inch: 0.1299,
    mm: 3.3,
    Drill: '3.3 mm',
  },
  {
    inch: 0.1339,
    mm: 3.4,
    Drill: '3.4 mm',
  },
  {
    inch: 0.136,
    mm: 3.454,
    Drill: '#29',
  },
  {
    inch: 0.1378,
    mm: 3.5,
    Drill: '3.5 mm',
  },
  {
    inch: 0.1405,
    mm: 3.569,
    Drill: '#28',
  },
  {
    inch: 0.1406,
    mm: 3.572,
    Drill: '9/64 in',
  },
  {
    inch: 0.1417,
    mm: 3.6,
    Drill: '3.6 mm',
  },
  {
    inch: 0.144,
    mm: 3.658,
    Drill: '#27',
  },
  {
    inch: 0.1457,
    mm: 3.7,
    Drill: '3.7 mm',
  },
  {
    inch: 0.147,
    mm: 3.734,
    Drill: '#26',
  },
  {
    inch: 0.1495,
    mm: 3.797,
    Drill: '#25',
  },
  {
    inch: 0.1496,
    mm: 3.8,
    Drill: '3.8 mm',
  },
  {
    inch: 0.152,
    mm: 3.861,
    Drill: '#24',
  },
  {
    inch: 0.1535,
    mm: 3.9,
    Drill: '3.9 mm',
  },
  {
    inch: 0.154,
    mm: 3.912,
    Drill: '#23',
  },
  {
    inch: 0.1563,
    mm: 3.969,
    Drill: '5/32 in',
  },
  {
    inch: 0.157,
    mm: 3.988,
    Drill: '#22',
  },
  {
    inch: 0.1575,
    mm: 4.0,
    Drill: '4 mm',
  },
  {
    inch: 0.159,
    mm: 4.039,
    Drill: '#21',
  },
  {
    inch: 0.161,
    mm: 4.089,
    Drill: '#20',
  },
  {
    inch: 0.1614,
    mm: 4.1,
    Drill: '4.1 mm',
  },
  {
    inch: 0.1654,
    mm: 4.2,
    Drill: '4.2 mm',
  },
  {
    inch: 0.166,
    mm: 4.216,
    Drill: '#19',
  },
  {
    inch: 0.1693,
    mm: 4.3,
    Drill: '4.3 mm',
  },
  {
    inch: 0.1695,
    mm: 4.305,
    Drill: '#18',
  },
  {
    inch: 0.1719,
    mm: 4.366,
    Drill: '11/64 in',
  },
  {
    inch: 0.173,
    mm: 4.394,
    Drill: '#17',
  },
  {
    inch: 0.1732,
    mm: 4.4,
    Drill: '4.4 mm',
  },
  {
    inch: 0.177,
    mm: 4.496,
    Drill: '#16',
  },
  {
    inch: 0.1772,
    mm: 4.5,
    Drill: '4.5 mm',
  },
  {
    inch: 0.18,
    mm: 4.572,
    Drill: '#15',
  },
  {
    inch: 0.1811,
    mm: 4.6,
    Drill: '4.6 mm',
  },
  {
    inch: 0.182,
    mm: 4.623,
    Drill: '#14',
  },
  {
    inch: 0.185,
    mm: 4.699,
    Drill: '#13',
  },
  {
    inch: 0.185,
    mm: 4.7,
    Drill: '4.7 mm',
  },
  {
    inch: 0.1875,
    mm: 4.763,
    Drill: '3/16 in',
  },
  {
    inch: 0.189,
    mm: 4.8,
    Drill: '4.8 mm',
  },
  {
    inch: 0.189,
    mm: 4.801,
    Drill: '#12',
  },
  {
    inch: 0.191,
    mm: 4.851,
    Drill: '#11',
  },
  {
    inch: 0.1929,
    mm: 4.9,
    Drill: '4.9 mm',
  },
  {
    inch: 0.1935,
    mm: 4.915,
    Drill: '#10',
  },
  {
    inch: 0.196,
    mm: 4.978,
    Drill: '#9',
  },
  {
    inch: 0.1969,
    mm: 5.0,
    Drill: '5 mm',
  },
  {
    inch: 0.199,
    mm: 5.055,
    Drill: '#8',
  },
  {
    inch: 0.2008,
    mm: 5.1,
    Drill: '5.1 mm',
  },
  {
    inch: 0.201,
    mm: 5.105,
    Drill: '#7',
  },
  {
    inch: 0.2031,
    mm: 5.159,
    Drill: '13/64 in',
  },
  {
    inch: 0.204,
    mm: 5.182,
    Drill: '#6',
  },
  {
    inch: 0.2047,
    mm: 5.2,
    Drill: '5.2 mm',
  },
  {
    inch: 0.2055,
    mm: 5.22,
    Drill: '#5',
  },
  {
    inch: 0.2087,
    mm: 5.3,
    Drill: '5.3 mm',
  },
  {
    inch: 0.209,
    mm: 5.309,
    Drill: '#4',
  },
  {
    inch: 0.2126,
    mm: 5.4,
    Drill: '5.4 mm',
  },
  {
    inch: 0.213,
    mm: 5.41,
    Drill: '#3',
  },
  {
    inch: 0.2165,
    mm: 5.5,
    Drill: '5.5 mm',
  },
  {
    inch: 0.2188,
    mm: 5.556,
    Drill: '7/32 in',
  },
  {
    inch: 0.2205,
    mm: 5.6,
    Drill: '5.6 mm',
  },
  {
    inch: 0.221,
    mm: 5.613,
    Drill: '#2',
  },
  {
    inch: 0.2244,
    mm: 5.7,
    Drill: '5.7 mm',
  },
  {
    inch: 0.228,
    mm: 5.791,
    Drill: '#1',
  },
  {
    inch: 0.2284,
    mm: 5.8,
    Drill: '5.8 mm',
  },
  {
    inch: 0.2323,
    mm: 5.9,
    Drill: '5.9 mm',
  },
  {
    inch: 0.234,
    mm: 5.944,
    Drill: 'A',
  },
  {
    inch: 0.2344,
    mm: 5.953,
    Drill: '15/64 in',
  },
  {
    inch: 0.2362,
    mm: 6.0,
    Drill: '6 mm',
  },
  {
    inch: 0.238,
    mm: 6.045,
    Drill: 'B',
  },
  {
    inch: 0.2402,
    mm: 6.1,
    Drill: '6.1 mm',
  },
  {
    inch: 0.242,
    mm: 6.147,
    Drill: 'C',
  },
  {
    inch: 0.2441,
    mm: 6.2,
    Drill: '6.2 mm',
  },
  {
    inch: 0.246,
    mm: 6.248,
    Drill: 'D',
  },
  {
    inch: 0.248,
    mm: 6.3,
    Drill: '6.3 mm',
  },
  {
    inch: 0.25,
    mm: 6.35,
    Drill: '1/4 in',
  },
  {
    inch: 0.25,
    mm: 6.35,
    Drill: 'E',
  },
  {
    inch: 0.252,
    mm: 6.4,
    Drill: '6.4 mm',
  },
  {
    inch: 0.2559,
    mm: 6.5,
    Drill: '6.5 mm',
  },
  {
    inch: 0.257,
    mm: 6.528,
    Drill: 'F',
  },
  {
    inch: 0.2598,
    mm: 6.6,
    Drill: '6.6 mm',
  },
  {
    inch: 0.261,
    mm: 6.629,
    Drill: 'G',
  },
  {
    inch: 0.2638,
    mm: 6.7,
    Drill: '6.7 mm',
  },
  {
    inch: 0.2656,
    mm: 6.747,
    Drill: '17/64 in',
  },
  {
    inch: 0.266,
    mm: 6.756,
    Drill: 'H',
  },
  {
    inch: 0.2677,
    mm: 6.8,
    Drill: '6.8 mm',
  },
  {
    inch: 0.2717,
    mm: 6.9,
    Drill: '6.9 mm',
  },
  {
    inch: 0.272,
    mm: 6.909,
    Drill: 'I',
  },
  {
    inch: 0.2756,
    mm: 7.0,
    Drill: '7 mm',
  },
  {
    inch: 0.277,
    mm: 7.036,
    Drill: 'J',
  },
  {
    inch: 0.2795,
    mm: 7.1,
    Drill: '7.1 mm',
  },
  {
    inch: 0.281,
    mm: 7.137,
    Drill: 'K',
  },
  {
    inch: 0.2813,
    mm: 7.144,
    Drill: '9/32 in',
  },
  {
    inch: 0.2835,
    mm: 7.2,
    Drill: '7.2 mm',
  },
  {
    inch: 0.2874,
    mm: 7.3,
    Drill: '7.3 mm',
  },
  {
    inch: 0.29,
    mm: 7.366,
    Drill: 'L',
  },
  {
    inch: 0.2913,
    mm: 7.4,
    Drill: '7.4 mm',
  },
  {
    inch: 0.295,
    mm: 7.493,
    Drill: 'M',
  },
  {
    inch: 0.2953,
    mm: 7.5,
    Drill: '7.5 mm',
  },
  {
    inch: 0.2969,
    mm: 7.541,
    Drill: '19/64 in',
  },
  {
    inch: 0.2992,
    mm: 7.6,
    Drill: '7.6 mm',
  },
  {
    inch: 0.302,
    mm: 7.671,
    Drill: 'N',
  },
  {
    inch: 0.3032,
    mm: 7.7,
    Drill: '7.7 mm',
  },
  {
    inch: 0.3071,
    mm: 7.8,
    Drill: '7.8 mm',
  },
  {
    inch: 0.311,
    mm: 7.9,
    Drill: '7.9 mm',
  },
  {
    inch: 0.3125,
    mm: 7.938,
    Drill: '5/16 in',
  },
  {
    inch: 0.315,
    mm: 8.0,
    Drill: '8 mm',
  },
  {
    inch: 0.316,
    mm: 8.026,
    Drill: 'O',
  },
  {
    inch: 0.3189,
    mm: 8.1,
    Drill: '8.1 mm',
  },
  {
    inch: 0.3228,
    mm: 8.2,
    Drill: '8.2 mm',
  },
  {
    inch: 0.323,
    mm: 8.204,
    Drill: 'P',
  },
  {
    inch: 0.3268,
    mm: 8.3,
    Drill: '8.3 mm',
  },
  {
    inch: 0.3281,
    mm: 8.334,
    Drill: '21/64 in',
  },
  {
    inch: 0.3307,
    mm: 8.4,
    Drill: '8.4 mm',
  },
  {
    inch: 0.332,
    mm: 8.433,
    Drill: 'Q',
  },
  {
    inch: 0.3347,
    mm: 8.5,
    Drill: '8.5 mm',
  },
  {
    inch: 0.3386,
    mm: 8.6,
    Drill: '8.6 mm',
  },
  {
    inch: 0.339,
    mm: 8.611,
    Drill: 'R',
  },
  {
    inch: 0.3425,
    mm: 8.7,
    Drill: '8.7 mm',
  },
  {
    inch: 0.3438,
    mm: 8.731,
    Drill: '11/32 in',
  },
  {
    inch: 0.3465,
    mm: 8.8,
    Drill: '8.8 mm',
  },
  {
    inch: 0.348,
    mm: 8.839,
    Drill: 'S',
  },
  {
    inch: 0.3504,
    mm: 8.9,
    Drill: '8.9 mm',
  },
  {
    inch: 0.3543,
    mm: 9.0,
    Drill: '9 mm',
  },
  {
    inch: 0.358,
    mm: 9.093,
    Drill: 'T',
  },
  {
    inch: 0.3583,
    mm: 9.1,
    Drill: '9.1 mm',
  },
  {
    inch: 0.3594,
    mm: 9.128,
    Drill: '23/64 in',
  },
  {
    inch: 0.3622,
    mm: 9.2,
    Drill: '9.2 mm',
  },
  {
    inch: 0.3661,
    mm: 9.3,
    Drill: '9.3 mm',
  },
  {
    inch: 0.368,
    mm: 9.347,
    Drill: 'U',
  },
  {
    inch: 0.3701,
    mm: 9.4,
    Drill: '9.4 mm',
  },
  {
    inch: 0.374,
    mm: 9.5,
    Drill: '9.5 mm',
  },
  {
    inch: 0.375,
    mm: 9.525,
    Drill: '3/8 in',
  },
  {
    inch: 0.377,
    mm: 9.576,
    Drill: 'V',
  },
  {
    inch: 0.378,
    mm: 9.6,
    Drill: '9.6 mm',
  },
  {
    inch: 0.3819,
    mm: 9.7,
    Drill: '9.7 mm',
  },
  {
    inch: 0.3858,
    mm: 9.8,
    Drill: '9.8 mm',
  },
  {
    inch: 0.386,
    mm: 9.804,
    Drill: 'W',
  },
  {
    inch: 0.3898,
    mm: 9.9,
    Drill: '9.9 mm',
  },
  {
    inch: 0.3906,
    mm: 9.922,
    Drill: '25/64 in',
  },
  {
    inch: 0.3937,
    mm: 10.0,
    Drill: '10 mm',
  },
  {
    inch: 0.397,
    mm: 10.084,
    Drill: 'X',
  },
  {
    inch: 0.404,
    mm: 10.262,
    Drill: 'Y',
  },
  {
    inch: 0.4063,
    mm: 10.319,
    Drill: '13/32 in',
  },
  {
    inch: 0.413,
    mm: 10.49,
    Drill: 'Z',
  },
  {
    inch: 0.4134,
    mm: 10.5,
    Drill: '10.5 mm',
  },
  {
    inch: 0.4219,
    mm: 10.716,
    Drill: '27/64 in',
  },
  {
    inch: 0.4331,
    mm: 11.0,
    Drill: '11 mm',
  },
  {
    inch: 0.4375,
    mm: 11.113,
    Drill: '7/16 in',
  },
  {
    inch: 0.4528,
    mm: 11.5,
    Drill: '11.5 mm',
  },
  {
    inch: 0.4531,
    mm: 11.509,
    Drill: '29/64 in',
  },
  {
    inch: 0.4688,
    mm: 11.906,
    Drill: '15/32 in',
  },
  {
    inch: 0.4724,
    mm: 12.0,
    Drill: '12 mm',
  },
  {
    inch: 0.4844,
    mm: 12.303,
    Drill: '31/64 in',
  },
  {
    inch: 0.4921,
    mm: 12.5,
    Drill: '12.5 mm',
  },
  {
    inch: 0.5,
    mm: 12.7,
    Drill: '1/2 in',
  },
  {
    inch: 0.5118,
    mm: 13.0,
    Drill: '13 mm',
  },
  {
    inch: 0.5156,
    mm: 13.097,
    Drill: '33/64 in',
  },
  {
    inch: 0.5313,
    mm: 13.494,
    Drill: '17/32 in',
  },
  {
    inch: 0.5315,
    mm: 13.5,
    Drill: '13.5 mm',
  },
  {
    inch: 0.5469,
    mm: 13.891,
    Drill: '35/64 in',
  },
  {
    inch: 0.5512,
    mm: 14.0,
    Drill: '14 mm',
  },
  {
    inch: 0.5625,
    mm: 14.288,
    Drill: '9/16 in',
  },
  {
    inch: 0.5709,
    mm: 14.5,
    Drill: '14.5 mm',
  },
  {
    inch: 0.5781,
    mm: 14.684,
    Drill: '37/64 in',
  },
  {
    inch: 0.5906,
    mm: 15.0,
    Drill: '15 mm',
  },
  {
    inch: 0.5938,
    mm: 15.081,
    Drill: '19/32 in',
  },
  {
    inch: 0.6094,
    mm: 15.478,
    Drill: '39/64 in',
  },
  {
    inch: 0.6102,
    mm: 15.5,
    Drill: '15.5 mm',
  },
  {
    inch: 0.625,
    mm: 15.875,
    Drill: '5/8 in',
  },
  {
    inch: 0.6299,
    mm: 16.0,
    Drill: '16 mm',
  },
  {
    inch: 0.6406,
    mm: 16.272,
    Drill: '41/64 in',
  },
  {
    inch: 0.6496,
    mm: 16.5,
    Drill: '16.5 mm',
  },
  {
    inch: 0.6693,
    mm: 17.0,
    Drill: '17 mm',
  },
  {
    inch: 0.6719,
    mm: 17.066,
    Drill: '43/64 in',
  },
  {
    inch: 0.6875,
    mm: 17.463,
    Drill: '11/16 in',
  },
  {
    inch: 0.689,
    mm: 17.5,
    Drill: '17.5 mm',
  },
  {
    inch: 0.7031,
    mm: 17.859,
    Drill: '45/64 in',
  },
  {
    inch: 0.7087,
    mm: 18.0,
    Drill: '18 mm',
  },
  {
    inch: 0.7188,
    mm: 18.256,
    Drill: '23/32 in',
  },
  {
    inch: 0.7284,
    mm: 18.5,
    Drill: '18.5 mm',
  },
  {
    inch: 0.7344,
    mm: 18.653,
    Drill: '47/64 in',
  },
  {
    inch: 0.748,
    mm: 19.0,
    Drill: '19 mm',
  },
  {
    inch: 0.75,
    mm: 19.05,
    Drill: '3/4 in',
  },
  {
    inch: 0.7656,
    mm: 19.447,
    Drill: '49/64 in',
  },
  {
    inch: 0.7677,
    mm: 19.5,
    Drill: '19.5 mm',
  },
  {
    inch: 0.7813,
    mm: 19.844,
    Drill: '25/32 in',
  },
  {
    inch: 0.7874,
    mm: 20.0,
    Drill: '20 mm',
  },
  {
    inch: 0.7969,
    mm: 20.241,
    Drill: '51/64 in',
  },
  {
    inch: 0.8071,
    mm: 20.5,
    Drill: '20.5 mm',
  },
  {
    inch: 0.8125,
    mm: 20.638,
    Drill: '13/16 in',
  },
  {
    inch: 0.8268,
    mm: 21.0,
    Drill: '21 mm',
  },
  {
    inch: 0.8281,
    mm: 21.034,
    Drill: '53/64 in',
  },
  {
    inch: 0.8438,
    mm: 21.431,
    Drill: '27/32 in',
  },
  {
    inch: 0.8465,
    mm: 21.5,
    Drill: '21.5 mm',
  },
  {
    inch: 0.8594,
    mm: 21.828,
    Drill: '55/64 in',
  },
  {
    inch: 0.8661,
    mm: 22.0,
    Drill: '22 mm',
  },
  {
    inch: 0.875,
    mm: 22.225,
    Drill: '7/8 in',
  },
  {
    inch: 0.8858,
    mm: 22.5,
    Drill: '22.5 mm',
  },
  {
    inch: 0.8906,
    mm: 22.622,
    Drill: '57/64 in',
  },
  {
    inch: 0.9055,
    mm: 23.0,
    Drill: '23 mm',
  },
  {
    inch: 0.9063,
    mm: 23.019,
    Drill: '29/32 in',
  },
  {
    inch: 0.913,
    mm: 23.191,
    Drill: '21/23 in',
  },
  {
    inch: 0.9219,
    mm: 23.416,
    Drill: '59/64 in',
  },
  {
    inch: 0.9252,
    mm: 23.5,
    Drill: '23.5 mm',
  },
  {
    inch: 0.9375,
    mm: 23.813,
    Drill: '15/16 in',
  },
  {
    inch: 0.9449,
    mm: 24.0,
    Drill: '24 mm',
  },
  {
    inch: 0.9531,
    mm: 24.209,
    Drill: '61/64 in',
  },
  {
    inch: 0.9646,
    mm: 24.5,
    Drill: '24.5 mm',
  },
  {
    inch: 0.9688,
    mm: 24.606,
    Drill: '31/32 in',
  },
  {
    inch: 0.9843,
    mm: 25.0,
    Drill: '25 mm',
  },
  {
    inch: 0.9844,
    mm: 25.003,
    Drill: '63/64 in',
  },
  {
    inch: 1.0,
    mm: 25.4,
    Drill: '1 in',
  },
];

export default DrillData;
